import { Record } from 'immutable';
import { DOWNLOAD_STATES } from 'constants/design'

const defaultValues = {
  loading: false,
  errorMessage: null,
  downloadingState: DOWNLOAD_STATES.IDLE,
  data: Record(),
};

export default class Base extends Record(defaultValues, Base) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
